import PaySuiteMfePage from '@/components/paysuite/PaySuiteMfePage';

const MFE_INSTANCE_ID = 'a49aadbe-937e-4b4d-a4ef-4b1995ef7afe';

export default function PaymentReportingPage() {
  return (
    <PaySuiteMfePage
      title="Payment Reporting"
      description="View and analyse payment reports"
      componentName="pay-reporting"
      instanceId={MFE_INSTANCE_ID}
    />
  );
}
